import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  getChartTitles,
  getYears,
  createNew,
  addChemicals,
  addMeasurement,
  addLevel,
  clearMum,
  editChart,
  copyChart,
  deleteChart,
  updateTable,
  saveTable,
} from '../../redux/actions/mumActions.js';

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
} from "reactstrap";


import { Edit, PlusCircle, Save, Copy } from "react-feather";
import MumChart from "./MumChart.js";

const Mum = ({
  getChartTitles,
  getYears,
  createNew,
  mum,
  addChemicals,
  addMeasurement,
  addLevel,
  clearMum,
  editChart,
  copyChart,
  deleteChart,
  updateTable,
  saveTable,
}) => {
  useEffect(() => {
    getChartTitles(mum.date);
    getYears();
    setCreateForm(false);
  }, [mum.chart, mum.date]);

//Create Form State
const [create, setCreate] = useState({
    location: '',
    color: '',
    size: '',
    heightGoal: '',
    span: '',
    pinchDate: '',
    readyDate: '',
  })
const changeCreate = e => setCreate({...create, [e.target.name]: e.target.value});
const editCreate = () => {
  setCreate({
    location: mum.chart.location,
    color: mum.chart.color,
    size: mum.chart.size,
    heightGoal: mum.chart.heightGoal,
    span: mum.chart.span,
    pinchDate: moment.utc(mum.chart.pinchDate).format('YYYY-MM-DD'),
    readyDate: moment.utc(mum.chart.readyDate).format('YYYY-MM-DD'),
  })
  setCreateForm(true)
}

const [editCreateForm, setCreateForm] = useState(false)

const sendCreate = () => {
  createNew(create)
  setCreate({
    location: '',
    color: '',
    size: '',
    heightGoal: '',
    span: '',
    pinchDate: '',
    readyDate: '',
  })
}

// ADD Chemical State
const [chemical, setChemical] = useState({
  date: moment().format('YYYY-MM-DD'),
  chemical: '',
  rate: '',
  note: '',
})
const changeChemical = e => setChemical({...chemical, [e.target.name]: e.target.value});
const sendChemical = () => {
  addChemicals(mum.chart._id, chemical)
  setChemical({
    date: moment().format('YYYY-MM-DD'),
    chemical: '',
    rate: '',
    note: '',
  })
}
// Add measurement
const [measurement, setMeasurement] = useState({
  date: moment().format('YYYY-MM-DD'),
  m1: '',
  m2: '',
  m3: '',
  m4: '',
  m5: ''
})
const changeMeasurement = e => setMeasurement({...measurement, [e.target.name]: e.target.value});
const sendMeasurement = e => {
  addMeasurement(mum.chart._id, measurement);
  setMeasurement({
    date: moment().format('YYYY-MM-DD'),
    m1: '',
    m2: '',
    m3: '',
    m4: '',
    m5: ''
  });
}
// Add Level
const [level, setLevel] = useState({
  date: moment().format('YYYY-MM-DD'),
  ph: '',
  ec: ''
})
const changeLevel = e => setLevel({...level, [e.target.name]: e.target.value});
const sendLevel = e => {
  addLevel(mum.chart._id, level)
  setLevel({
    date: moment().format('YYYY-MM-DD'),
    ph: '',
    ec: ''
  })
}

const  details = () => {
  if(mum.chart._id){
    switch(editCreateForm){
      case true:
        return(
          <Card>
            <CardBody>
              <Table size="sm" className="my-2">
                <tbody>
                  <tr>
                    <th>Location</th>
                    <td>
                      <Input type="text" name="location" placeholder="text" value={create.location} onChange={(e) => changeCreate(e)}/>
                    </td>
                  </tr>
                  <tr>
                    <th>Color</th>
                      <td>
                        <Input type="text" name="color" placeholder="text" value={create.color} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                  <tr>
                    <th>Size</th>
                      <td>
                        <Input type="text" name="size" placeholder="pot size" value={create.size} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                  <tr>
                    <th>Height Goal (in)</th>
                      <td>
                        <Input type="number" name="heightGoal" placeholder="number" value={create.heightGoal} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                  <tr>
                    <th>Acceptable Span (in)</th>
                      <td>
                        <Input type="number" name="span" placeholder="number" value={create.span} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                  <tr>
                    <th>Pinch Date</th>
                      <td>
                        <Input type="date" name="pinchDate"  value={create.pinchDate} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                  <tr>
                    <th>Ready Date</th>
                      <td>
                        <Input type="date" name="readyDate"  value={create.readyDate} onChange={(e) => changeCreate(e)}/>
                      </td>
                  </tr>
                </tbody>
              </Table>
              <hr />
              <Button onClick={() => editChart(mum.chart._id, create)}><Save/> Save</Button>
            </CardBody>
          </Card>
        )
      default:
        return(
          <Card>
            <CardBody>
              <Table size="sm" className="my-2">
                <tbody>
                  <tr>
                    <th>Crop Name</th>
                    <td><code>{mum.chart.chartTitle}</code></td>
                  </tr>
                  <tr>
                    <th>Location</th>
                    <td><code>{mum.chart.location}</code></td>
                  </tr>
                  <tr>
                    <th>Color</th>
                    <td><code>{mum.chart.color}</code></td>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <td><code>{mum.chart.size}</code></td>
                  </tr>
                  <tr>
                    <th>Height Goal (in)</th>
                    <td><code>{mum.chart.heightGoal}</code></td>
                  </tr>
                  <tr>
                    <th>Acceptable Span (in)</th>
                    <td><code>{mum.chart.span}</code></td>
                  </tr>
                  <tr>
                    <th>Pinch Date</th>
                    <td><code>{moment.utc(mum.chart.pinchDate).format('MM/DD/YYYY')}</code></td>
                  </tr>
                  <tr>
                    <th>Ready Date</th>
                    <td><code>{moment.utc(mum.chart.readyDate).format('MM/DD/YYYY')}</code></td>
                  </tr>
                </tbody>
              </Table>

              <hr />

              <span><Button onClick={() => editCreate()}><Edit/> Edit</Button> <Button className="float-right" onClick={() => copyChart(mum.chart)}><Copy/> Copy</Button></span>

            </CardBody>
          </Card>
        )
    }
  } else {
    return (
      <Card>
        <CardBody>
          <Table size="sm" className="my-2">
            <tbody>
              <tr>
                <th>Location</th>
                <td>
                  <Input type="text" name="location" placeholder="text" value={create.location} onChange={(e) => changeCreate(e)}/>
                </td>
              </tr>
              <tr>
                <th>Color</th>
                  <td>
                    <Input type="text" name="color" placeholder="text" value={create.color} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
              <tr>
                <th>Size</th>
                  <td>
                    <Input type="text" name="size" placeholder="pot size" value={create.size} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
              <tr>
                <th>Height Goal (in)</th>
                  <td>
                    <Input type="number" name="heightGoal" placeholder="number" value={create.heightGoal} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
              <tr>
                <th>Acceptable Span (in)</th>
                  <td>
                    <Input type="number" name="span" placeholder="number" value={create.span} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
              <tr>
                <th>Pinch Date</th>
                  <td>
                    <Input type="date" name="pinchDate"  value={create.pinchDate} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
              <tr>
                <th>Ready Date</th>
                  <td>
                    <Input type="date" name="readyDate"  value={create.readyDate} onChange={(e) => changeCreate(e)}/>
                  </td>
              </tr>
            </tbody>
          </Table>
          <hr />
          <Button onClick={() => sendCreate()}>Create New</Button>
        </CardBody>
      </Card>
    )
  }
}

const [editTable, setEditTable] = useState(false)
const tableData = () => {
  switch(editTable){
    case true:
      return(
        <tbody>
            {(mum.chart.table) &&
              mum.chart.table.map((data, index) =>
              <tr index={index}>
                <th scope="row">{moment.utc(data.date).format('YYYY-MM-DD')}</th>
                {(data.measurement) &&
                  <td><input type="number" value={data.measurement} name="measurement" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                }
                {(!data.measurement) &&
                  <td><input type="number" value={data.measurement} name="measurement" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                }
                <td><input type="number" value={data.ph} name="ph" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                <td><input type="number" value={data.ec} name="ec" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                <td><input value={data.chemical} name="chemical" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                <td><input value={data.rate} name="rate" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
                <td><input value={data.note} name="note" onChange={(e) => updateTable(mum.chart.table, index, e)}></input></td>
              </tr>
            )}
        </tbody>
      )
    default:
      return(
        <tbody>
            {(mum.chart.table) &&
              mum.chart.table.map((data, index) =>
              <tr key={index}>
                <th scope="row">{moment.utc(data.date).format('MM/DD/YYYY')}</th>
                {(data.measurement) &&
                  <td>{data.measurement.toFixed(2)}</td>
                }
                {(!data.measurement) &&
                  <td>{null}</td>
                }
                <td>{data.ph}</td>
                <td>{data.ec}</td>
                <td>{data.chemical}</td>
                <td>{data.rate}</td>
                <td>{data.note}</td>
              </tr>
            )}
        </tbody>
      )
  }
}
  return (
  <Container fluid className="p-0">
    <h1 className="h3 mb-3"><Button onClick={() => clearMum()}><PlusCircle/> Create New Poinsettia</Button></h1>
    <Row>
      <Col lg="3" >
        {details()}
      </Col>
      <Col lg="9" >
        {(mum.chartYears) && <MumChart />}
      </Col>
    </Row>
    <Row>
      <Col lg="4" className="addChemicals">
        <Card>
        <CardHeader>
          <CardTitle tag="h5">Chemicals</CardTitle>
          <h6 className="card-subtitle text-muted">Apply Chemicals</h6>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Date:
              </Label>
              <Col sm={9}>
                <Input type="date" name="date"  value={chemical.date} onChange={(e) => changeChemical(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Chemical:
              </Label>
              <Col sm={9}>
                <Input name="chemical" placeholder="Chemical Name"  value={chemical.chemical} onChange={(e) => changeChemical(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Rate:
              </Label>
              <Col sm={9}>
                <Input name="rate" placeholder="PPM"  value={chemical.rate} onChange={(e) => changeChemical(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Note:
              </Label>
              <Col sm={9}>
                <Input
                  type="textarea"
                  name="note"
                  placeholder="Add a note"
                  rows="3"
                   value={chemical.note} onChange={(e) => changeChemical(e)}
                  required
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 10, offset: 2 }}>
                <Button color="primary" onClick={() => sendChemical()}>Submit</Button>
              </Col>
            </FormGroup>
          </Form>
        </CardBody>
        </Card>
      </Col>
      <Col lg="4" className="addMeasurement">
        <Card>
        <CardHeader>
          <CardTitle tag="h5">Measurement</CardTitle>
          <h6 className="card-subtitle text-muted">Height(in) from floor.</h6>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Date:
              </Label>
              <Col sm={9}>
                <Input type="date" name="date" value={measurement.date} onChange={(e) => changeMeasurement(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Measurement 1:
              </Label>
              <Col sm={9}>
                <Input type="number" name="m1" value={measurement.m1} onChange={(e) => changeMeasurement(e)} placeholder="Add Measurement" required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Measurement 2:
              </Label>
              <Col sm={9}>
                <Input type="number" name="m2" value={measurement.m2} onChange={(e) => changeMeasurement(e)} placeholder="Add Measurement" required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Measurement 3:
              </Label>
              <Col sm={9}>
                <Input type="number" name="m3" placeholder="Add Measurement" value={measurement.m3} onChange={(e) => changeMeasurement(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Measurement 4:
              </Label>
              <Col sm={9}>
                <Input type="number" name="m4" placeholder="Add Measurement" value={measurement.m4} onChange={(e) => changeMeasurement(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Measurement 5:
              </Label>
              <Col sm={9}>
                <Input type="number" name="m5" placeholder="Add Measurement" value={measurement.m5} onChange={(e) => changeMeasurement(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 10, offset: 2 }}>
                <Button color="primary" onClick={() => sendMeasurement()}>Submit</Button>
              </Col>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
      </Col>
      <Col lg="4" className="addLevel">
        <Card>
          <CardHeader>
            <CardTitle tag="h5">Levels</CardTitle>
            <h6 className="card-subtitle text-muted">Measure Ph/Ec levels.</h6>
          </CardHeader>
          <CardBody>
            <Form>
              <FormGroup row>
                <Label sm={3} className="text-sm-left">
                  Date:
                </Label>
                <Col sm={9}>
                  <Input type="date" name="date" value={level.date} onChange={(e) => changeLevel(e)} required/>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3} className="text-sm-left">
                  Ph:
                </Label>
                <Col sm={9}>
                  <Input
                    type="number"
                    name="ph"
                    placeholder="Ph Level"
                    value={level.ph}
                    onChange={(e) => changeLevel(e)}
                    required/>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3} className="text-sm-left">
                  Ec:
                </Label>
                <Col sm={9}>
                  <Input
                    type="number"
                    name="ec"
                    placeholder="Ec level"
                    value={level.ec}
                    onChange={(e) => changeLevel(e)}
                    required/>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col sm={{ size: 10, offset: 2 }}>
                  <Button color="primary" onClick={() => sendLevel()}>Submit</Button>
                </Col>
              </FormGroup>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col lg="12">
        <Card >
          <CardHeader>
            <CardTitle tag="h5">Poinsettia History</CardTitle>
            <h6 className="card-subtitle text-muted">
              {(!editTable) &&
                <Button onClick={() => setEditTable(true)}><Edit/>Edit Table</Button>
              }
              {(editTable) &&
                <Button onClick={() => {setEditTable(false); saveTable(mum.chart._id, mum.chart.table)}}><Save/>Save Table</Button>
              }
            </h6>
          </CardHeader>
          <Table responsive>
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Height</th>
                <th scope="col">Ph</th>
                <th scope="col">Ec</th>
                <th scope="col">Chemical Name</th>
                <th scope="col">Chemical Amount</th>
                <th scope="col">Chemical Note</th>
              </tr>
            </thead>
            {tableData()}
          </Table>
        </Card>
      </Col>
    </Row>
    {(mum.chart._id) &&
      <Row>
        <Col sm="12">
          <Button className="sm btn-danger float-right" onClick={() => deleteChart(mum.chart._id)}>Delete Chart</Button>
        </Col>
      </Row>
    }
  </Container>
  )
};

Mum.propTypes = {
  getChartTitles: PropTypes.func.isRequired,
  getYears: PropTypes.func.isRequired,
  createNew: PropTypes.func.isRequired,
  addChemicals: PropTypes.func.isRequired,
  addMeasurement: PropTypes.func.isRequired,
  addLevel: PropTypes.func.isRequired,
  clearMum: PropTypes.func.isRequired,
  editChart: PropTypes.func.isRequired,
  copyChart: PropTypes.func.isRequired,
  deleteChart: PropTypes.func.isRequired,
  updateTable: PropTypes.func.isRequired,
  saveTable: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  mum: state.mum
})

export default connect(mapStateToProps, {saveTable, updateTable, deleteChart, copyChart, editChart, clearMum, getChartTitles, getYears, createNew, addChemicals, addMeasurement, addLevel})(Mum);
